import React from 'react';
import { Container, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';

import { useAuth } from '@src/context';
import EmailRecipientsForm from './components/EmailRecipientsForm';

export default function FiveStarEmailNotificationsPage() {
  const { state: authState } = useAuth();
  const memberships = authState?.user?.client_memberships || [];
  const defaultMembership = memberships[0];
  const clientSlug = defaultMembership?.client_slug || defaultMembership?.client_id || '';

  return (
    <>
      <Helmet><title>Email Notifications</title></Helmet>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Email Notifications
        </Typography>
        <EmailRecipientsForm
          clientSlug={clientSlug}
          helperText="Anyone you list here will receive an email for every lead that comes in for your branch."
        />
      </Container>
    </>
  );
}
